import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import ApiService from '../../../services/api.service';
const initialState = {
  projectAllStores: [],
  status: false,
  error: null,
};
export const fetchAllProjectStores = createAsyncThunk(
  'master/fetchAllProjectStores',
  async (_, { getState, rejectWithValue }) => {
    const { projectAllStores } = getState().projectAllStores;
    if (projectAllStores && projectAllStores.length > 0) {
      return rejectWithValue('Stores already fetched');
    } else {
      const response = await ApiService.get('/stores/all-stores');
      return response;
    }
  }
);
const projectAllStoresSlice = createSlice({
  name: 'projectAllStores',
  initialState,
  reducers: {
    clearStore: state => {
      state.projectAllStores = [];
      state.status = false;
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchAllProjectStores.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchAllProjectStores.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.projectAllStores = action?.payload || [];
      })
      .addCase(fetchAllProjectStores.rejected, (state, action) => {
        if (action.payload === 'Stores already fetched') {
          state.status = 'succeeded';
        } else {
          state.status = 'failed';
          state.error = action.error.message;
        }
      });
  },
});

export const { clearStore } = projectAllStoresSlice.actions;

export const projectAllStoresReducer = projectAllStoresSlice.reducer;
